import React from "react";
import {
  View,
  Image,
  useTheme,
  Heading,
  useAuthenticator,
  Button,
  Text,
  Authenticator,
} from "@aws-amplify/ui-react";
import { Helmet } from "react-helmet";
import logo from "../public/Coin Basis Icon.svg"; // Update the path to the correct location
import { Link } from "react-router-dom";

const components = {
  Header() {
    const { tokens } = useTheme();

    return (
      <View textAlign="center" padding={tokens.space.large}>
        <Image height={150} alt="Coin Basis logo" src={logo} />
      </View>
    );
  },

  Footer() {
    const { tokens } = useTheme();

    return (
      <View textAlign="center" padding={tokens.space.large}>
        <Text color={tokens.colors.neutral[80]}>
          &copy; All Rights Reserved
        </Text>
      </View>
    );
  },

  SignIn: {
    Header() {
      const { tokens } = useTheme();

      return (
        <Heading
          padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
          level={3}
        >
          Welcome Back!
        </Heading>
      );
    },
    Footer() {
      const { toForgotPassword } = useAuthenticator();

      return (
        <View textAlign="center">
          <Button
            fontWeight="normal"
            onClick={toForgotPassword}
            size="small"
            variation="link"
          >
            Reset Password
          </Button>
        </View>
      );
    },
  },

  SignUp: {
    Header() {
      const { tokens } = useTheme();

      return (
        <Heading
          padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
          level={3}
        >
          Create a new account
        </Heading>
      );
    },
    Footer() {
      const { toSignIn } = useAuthenticator();

      return (
        <View textAlign="center">
          <Text>
            By creating an account you agree to our{" "}
            <Link to="/faq#Terms-and-Privacy">terms and conditions</Link>
          </Text>
          <Button
            fontWeight="normal"
            onClick={toSignIn}
            size="small"
            variation="link"
          >
            Back to Sign In
          </Button>
        </View>
      );
    },
  },
  ConfirmSignUp: {
    // Header() {
    //   const { tokens } = useTheme();
    //   return (
    //     <Heading
    //       padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
    //       level={3}
    //     >
    //       Enter Information:
    //     </Heading>
    //   );
    // },
    // Footer() {
    //   return <Text>Footer Information</Text>;
    // },
  },
  SetupTotp: {
    // Header() {
    //   const { tokens } = useTheme();
    //   return (
    //     <Heading
    //       padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
    //       level={3}
    //     >
    //       Enter Information:
    //     </Heading>
    //   );
    // },
    // Footer() {
    //   return <Text>Footer Information</Text>;
    // },
  },
  ConfirmSignIn: {
    // Header() {
    //   const { tokens } = useTheme();
    //   return (
    //     <Heading
    //       padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
    //       level={3}
    //     >
    //       Enter Information:
    //     </Heading>
    //   );
    // },
    // Footer() {
    //   return <Text>Footer Information</Text>;
    // },
  },
  ForgotPassword: {
    // Header() {
    //   const { tokens } = useTheme();
    //   return (
    //     <Heading
    //       padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
    //       level={3}
    //     >
    //       Enter Information:
    //     </Heading>
    //   );
    // },
    // Footer() {
    //   return <Text>Footer Information</Text>;
    // },
  },
  ConfirmResetPassword: {
    // Header() {
    //   const { tokens } = useTheme();
    //   return (
    //     <Heading
    //       padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
    //       level={3}
    //     >
    //       Enter Information:
    //     </Heading>
    //   );
    // },
    // Footer() {
    //   return <Text>Footer Information</Text>;
    // },
  },
};

// const formFields = {
//   signIn: {
//     username: {
//       placeholder: 'Enter your email',
//     },
//   },
//   signUp: {
//     password: {
//       label: 'Password:',
//       placeholder: 'Enter your Password:',
//       isRequired: false,
//       order: 2,
//     },
//     confirm_password: {
//       label: 'Confirm Password:',
//       order: 1,
//     },
//   },
//   forceNewPassword: {
//     password: {
//       placeholder: 'Enter your Password:',
//     },
//   },
//   forgotPassword: {
//     username: {
//       placeholder: 'Enter your email:',
//     },
//   },
//   confirmResetPassword: {
//     confirmation_code: {
//       placeholder: 'Enter your Confirmation Code:',
//       label: 'New Label',
//       isRequired: false,
//     },
//     confirm_password: {
//       placeholder: 'Enter your Password Please:',
//     },
//   },
//   setupTotp: {
//     QR: {
//       totpIssuer: 'test issuer',
//       totpUsername: 'amplify_qr_test_user',
//     },
//     confirmation_code: {
//       label: 'New Label',
//       placeholder: 'Enter your Confirmation Code:',
//       isRequired: false,
//     },
//   },
//   confirmSignIn: {
//     confirmation_code: {
//       label: 'New Label',
//       placeholder: 'Enter your Confirmation Code:',
//       isRequired: false,
//     },
//   },
// };

const formFields = {
  signUp: {
    given_name: {
      label: "First Name",
      placeholder: "Enter your First Name",
      order: 1,
    },
    family_name: {
      label: "Last Name",
      placeholder: "Enter your Last Name",
      order: 2,
    },
  },
};

// Custom Auth UI Component
const CustomAuthUI = ({ children }) => {
  const originalUrl = React.useRef(window.location.pathname);

  React.useEffect(() => {
    // Update URL to /signin without adding to browser history
    window.history.replaceState(null, "", "/signin");

    // Cleanup function to restore original URL when component unmounts
    return () => {
      // eslint-disable-next-line
      window.history.replaceState(null, "", originalUrl.current);
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>Coin Basis - Sign In</title>
      </Helmet>
      <Authenticator formFields={formFields} components={components}>
        {({ signOut, user }) => {
          if (user) {
            // After successful sign in, redirect to the original URL
            window.history.replaceState(null, "", originalUrl.current);
          }
          return children;
        }}
      </Authenticator>
    </>
  );
};

// Custom HOC for Authentication
export const withCustomAuthenticator = (WrappedComponent) => {
  return (props) => (
    <CustomAuthUI>
      <WrappedComponent {...props} />
    </CustomAuthUI>
  );
};
